import { z } from 'zod';

export const EditarUsuarioUiSchema = z.object({
  nombre: z.string().min(1, 'El nombre es requerido'),
  apellido: z.string().min(1, 'El apellido es requerido')
});

export type EditarUsuarioUi = z.infer<typeof EditarUsuarioUiSchema>; 